import React from 'react';

import FileInput from './components/FileInput';
import FileAttached from './components/FileAttached';

import { WrapperTagInfo, Subtitle } from './styles';
import ContainerPage from '../../../../components/ContainerPage';
import HeadTitle from '../../../../components/HeadTitle';
import TagAlert from '../../../../components/TagAlert';
import TagInfo from '../../../../components/TagInfo';
import { Button, LoadingOverlay } from '../../../../components';
import { uploadFiles } from '../../../../modules/uploadFile';
import { Page, useCheckUpRouter } from '../../router/context';

const InfoImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg';

type UploadDocumentsPageProps = {
  requestId: number;
};

export const UploadDocumentsPage = ({ requestId, ...rest }: UploadDocumentsPageProps) => {
  const [uploadedFiles, setUploadedFiles] = React.useState<File[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [showAlertLimitSize, setShowAlertLimitSize] = React.useState(false);

  const router = useCheckUpRouter();

  function handleRemoveFile(fileIndex: number) {
    setUploadedFiles(uploadedFiles.filter((_, index) => fileIndex !== index));
  }

  const addFiles = (files: File[]) => {
    setUploadedFiles([...uploadedFiles, ...files]);
  };

  const maxSize = 5 * 1024 * 1024;

  const uploadDocuments = async () => {
    setLoading(true);

    const result = await uploadFiles({ files: uploadedFiles, requestId });

    if (!result.error) router.navigate(Page.APPOINTMENT_CONFIRMATION, { ...rest });

    setLoading(false);
  };

  return (
    <ContainerPage
      childrenFooter={
        <>
          <Button title="Continuar" onClick={uploadDocuments} />
        </>
      }
    >
      <HeadTitle title="Upload de Documentos" goBack={() => router.goBack()} />
      {showAlertLimitSize && (
        <TagAlert
          info="O arquivo que você escolheu excede o limite de 5mb."
          closeButton
          onClickClose={() => setShowAlertLimitSize(false)}
        />
      )}
      <WrapperTagInfo>
        <TagInfo
          icon={<img src={InfoImg} alt="info" />}
          info="Você pode enviar até 10 anexos (PNG, JPG ou PDF) com tamanho máximo de 5mb."
        />
      </WrapperTagInfo>
      <FileInput
        id="fileInput-documents"
        icon="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arquivo.svg"
        text="Documentos ou exames"
        accept="application/pdf"
        uploadedFiles={uploadedFiles}
        onChange={addFiles}
        maxSize={maxSize}
        setShowAlertLimitSize={setShowAlertLimitSize}
        multiple
      />
      <FileInput
        id="fileInput-images"
        icon="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/foto.svg"
        text="Fotos"
        accept="image/*, .png, .jpg, .jpeg"
        uploadedFiles={uploadedFiles}
        onChange={addFiles}
        maxSize={maxSize}
        setShowAlertLimitSize={setShowAlertLimitSize}
        multiple
      />
      {/*<FileInput*/}
      {/*  id="fileInput-camera"*/}
      {/*  icon="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/camera.svg"*/}
      {/*  text="Câmera"*/}
      {/*  accept="video/*"*/}
      {/*  capture*/}
      {/*  uploadedFiles={uploadedFiles}*/}
      {/*  setUploadedFiles={setUploadedFiles}*/}
      {/*  setShowAlertLimitSize={setShowAlertLimitSize}*/}
      {/*/>*/}

      {uploadedFiles.length > 0 && <Subtitle>Anexados</Subtitle>}
      {uploadedFiles.map((file: any, index: number) => (
        <FileAttached
          key={index + file.name + file.size}
          fileName={file.name}
          fileSize={file.size}
          onClick={() => handleRemoveFile(index)}
        />
      ))}
      <LoadingOverlay loading={loading} />
    </ContainerPage>
  );
};
